/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvitationStatus {
    PENDING = 'PENDING',
    DONE = 'DONE',
    ADDED_WITH_PASSWORD = 'ADDED_WITH_PASSWORD',
}
